<style scoped lang="scss" type="text/scss">
.left-panel-container {
  max-height: 100%;
  overflow: auto;
}
</style>

<template>
  <card class="left-panel-container">
    <complex-square-info-block
      v-for="(item, index) in items"
      :key="index"
      @click.native="redirect(item.route_name)"
      :active="currentRouteName === item.route_name"
      :icon="item.icon"
      :title="item.title"
    >
      {{ item.description }}
    </complex-square-info-block>
  </card>
</template>

<script>
import Card from "../../../../components/card/index";
import ComplexSquareInfoBlock from "../../../../components/square-info-block/complex";
import ROUTE_NAME from "../../../../router/names";

export default {
  name: "",
  components: {
    Card,
    ComplexSquareInfoBlock,
  },
  data() {
    return {
      items: [
        {
          title: "预报名信息填报",
          description: "统计本队预报名数量",
          icon: "&#xe616;",
          route_name: ROUTE_NAME.PLAYER.FORECAST_ATTENDANCE,
        },
        {
          title: "人员推荐",
          description: "推荐人员的采纳与否取决于组委会最后决定",
          icon: "&#xe616;",
          route_name: ROUTE_NAME.PLAYER.INFORMATION_RECOMMENDATION,
        },
        {
          title: "宣传员信息",
          description: "宣传员的信息",
          icon: "&#xe616;",
          route_name: ROUTE_NAME.PLAYER.INFORMATION_PROPAGANDIST,
        },
        {
          title: "物资购买联系人",
          description: "物资购买的联系人",
          icon: "&#xe616;",
          route_name: ROUTE_NAME.PLAYER.INFORMATION_PURCHASING,
        },
        {
          title: "解说基础信息",
          description: "用于比赛中对参赛队伍进行解说介绍",
          icon: "&#xe791;",
          route_name: ROUTE_NAME.PLAYER.INFORMATION_INTRODUCE,
        },
        {
          title: "机器人",
          description: "介绍用于比赛的机器人",
          icon: "&#xe612;",
          route_name: ROUTE_NAME.PLAYER.INFORMATION_ROBOT,
        },
        {
          title: "经费赞助",
          description: "填写用于比赛的经费，以及相关赞助信息",
          icon: "&#xe96b;",
          route_name: ROUTE_NAME.PLAYER.INFORMATION_SPONSORSHIP,
        },
        {
          title: "收件信息",
          description: "用于组委会向您寄送资料",
          icon: "&#xe617;",
          route_name: ROUTE_NAME.PLAYER.INFORMATION_CONSIGNEE,
        },
        {
          title: "到场情况",
          description: "填写实际当场人数",
          icon: "&#xe61a;",
          route_name: ROUTE_NAME.PLAYER.INFORMATION_PRESENT,
        },
        {
          title: "住宿信息",
          description: "填写参赛住宿信息",
          icon: "&#xe67c;",
          route_name: ROUTE_NAME.PLAYER.INFORMATION_ACCOMMODATION,
        },
        {
          title: "合照",
          description: "上传参赛队成员合照",
          icon: "&#xe619;",
          route_name: ROUTE_NAME.PLAYER.INFORMATION_GROUP_PHOTO,
        },
        {
          title: "单项赛报名",
          description: "选择是否报名单项赛",
          icon: "&#xe633;",
          route_name: ROUTE_NAME.PLAYER.INFORMATION_SPECIAL_COMPETITION,
        },
        // {
        //   title: "中期检查",
        //   description: "提交中期检查",
        //   icon: "&#xe633;",
        //   route_name: ROUTE_NAME.PLAYER.INFORMATION_MIDDLE_CHECK,
        // },
      ],
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    redirect(routeName) {
      this.$router.push({
        name: routeName,
      });
    },
  },
};
</script>
